import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { AuthenticationService } from '@app-services/auth/authentication.service';
import { USER_ROLE } from '@app-shared/constants/constants';
import { environment } from '@app-environments/environment';
import { IntervalService } from '@app-services/interval.service';
import { Router } from '@angular/router';
import { UserWorkspaceService } from '@app-services/user-workspace-service';
import { ROUTES } from '@app-shared/constants/routes/fe.routes';
import { MatchError } from '@app-services/errors/error-matcher';
import { SomethingWentWrongComponent } from '@app-components/common/error/something-went-wrong/something-went-wrong.component';

const { EMAILS, ERRORS, LOGOUT } = ROUTES;
const { RTA, ROOT } = USER_ROLE;

@Component({
  selector: 'app-home-page',
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    TranslateModule,
    SomethingWentWrongComponent,
  ],
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit, OnDestroy {
  authError: boolean;
  isLoggedIn = false;
  isError = false;

  constructor(
    private authenticationService: AuthenticationService,
    private intervalService: IntervalService,
    protected router: Router,
    private userWorkspaceService: UserWorkspaceService,
    public matchError: MatchError
  ) {}

  async ngOnInit(): Promise<void> {
    this.isLoggedIn = this.authenticationService.isLoggedIn();
    if (this.isLoggedIn) {
      await this.init();
    } else {
      const parameters = new URLSearchParams(window.location.search);
      const authError = parameters.get('status');
      this.authError = !!authError && authError === 'auth_error';
      this.authError &&
        this.router.navigateByUrl(`${LOGOUT}?status=auth_error`);
      if (this.authError) return;
      if (environment.isCredem) {
        this.logInCredem();
      } else {
        this.logIn();
      }
    }
  }

  async init(): Promise<void> {
    this.isError = false;
    try {
      !this.userWorkspaceService.user &&
        (await this.userWorkspaceService.getUserData());
      !this.userWorkspaceService.userOrganisaions.length &&
        (await this.userWorkspaceService.getUserOrganizations());
      !this.userWorkspaceService.userRole &&
        (await this.userWorkspaceService.getUserRole());

      if (
        this.userWorkspaceService.userRole === RTA ||
        this.userWorkspaceService.userRole === ROOT
      ) {
        this.router.navigateByUrl(
          this.userWorkspaceService.settingRoute
            ? this.userWorkspaceService.settingRoute
            : `/${EMAILS}`
        );
      } else {
        this.router.navigate([`/${EMAILS}`]);
      }
    } catch (e: any) {
      if (e.Status === 500) {
        await this.router.navigateByUrl(`/${ERRORS.SERVER_ERROR}`);
      }
      this.isError = true;
      this.matchError.logError(e);
    }
  }

  logIn(): void {
    this.authenticationService.logIn();
  }

  logInCredem(): void {
    this.authenticationService.logInCredem();
  }

  ngOnDestroy(): any {
    this.intervalService.clearAllIntervals();
  }
}
